import React from "react";
interface GenericpopupProps {
    isOpen: boolean;
    title?: string;
    message?: string;
    type?: "alert" | "confirm" | "custom";
    onConfirm?: () => void; // only for confirm type
    onClose?: () => void;
    children?: React.ReactNode; // for custom UI

}

const GenericPopup: React.FC<GenericpopupProps> = ({
    isOpen,
    title,
    message,
    type = 'alert',
    onClose,
    onConfirm,
    children,

}) => {
    if (!isOpen) return null;
    return (
        <div className="popup-overlay">
            <div className="popup-box">
                {/* 🔹 Header with title + close button */}
                <div className="popup-header">
                    {title && <h3 className='popup-title'>{title}</h3>}
                    {type === "custom" && onClose && (
                        <button className="close-popup-btn" onClick={onClose}>
                            &times;
                        </button>
                    )}
                </div>

                {message && <p className="popup-message">{message}</p>}

                {/* Custom content (like form / extra fields) */}
                {children && <div className="popup-custom">{children}</div>}

                <div className="popup-actions">
                    {type === 'confirm' && (
                        <>
                            <button className="yes-btn " onClick={onConfirm}>
                                Yes
                            </button>

                            <button className="no-btn" onClick={onClose}>No</button>

                        </>
                    )


                    }

                    {type === "alert" && (
                        <button className="yes-btn" onClick={onClose}>
                            OK
                        </button>
                    )}

                </div>



            </div>

        </div>
    );
};

export default GenericPopup;